import React from 'react'
import { Button, Row, Separator, useOverlay } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import SurnameOverlay from '../../components/SurnameOverlay/SurnameOverlay'
import SurnamePlaceHolderPage from '../../assets/thumbnails/generic-surname-page.webp'
import GlobalSurnamePlaceHolderPage from '../../assets/thumbnails/global-surname-page.webp'
import { useMemoryBook } from '../../providers/MemoryBookProvider'

const placeholderImgCSS = css`
  display: flex;
  justify-content: center;
  align-items: center;

  @media print {
    margin-top: 2em;
  }
`

const btnPrintCSS = css`
  @media print {
    display: none;
  }
`

export default function PlaceholderSurnamePage({ pageNumber, isGlobalSurnamePage = true }) {
  const [t] = useTranslation()
  const { currentViewingPages } = useMemoryBook()

  const surnameOverlay = useOverlay({ initiallyOpen: currentViewingPages.includes(pageNumber) })
  return (
    <>
      <div>
        <div css={placeholderImgCSS}>
          <img
            src={!isGlobalSurnamePage ? SurnamePlaceHolderPage : GlobalSurnamePlaceHolderPage}
            height="auto"
            width={!isGlobalSurnamePage ? '80%' : '90%'}
            alt={t('SurnamePage.placeholderPage.label', 'Placeholder Surname Page')}
          />
        </div>

        <div css={btnPrintCSS}>
          <Separator />
          <Row alignX="center" alignY="middle">
            <Button emphasis="medium" onClick={surnameOverlay.handleClick}>
              {t('SurnamePage.selectSurname.label', 'Select a Surname')}
            </Button>
          </Row>
        </div>
      </div>

      {(surnameOverlay.isOpen || surnameOverlay.transitioning) && (
        <SurnameOverlay overlay={surnameOverlay} pageNumber={pageNumber} isGlobalSurnamePage={isGlobalSurnamePage} />
      )}
    </>
  )
}
